export default "__VITE_ASSET__jhx3ZtKk__"